import { IChecklistWithResponses } from "features/requests/types/checklists";
import { AiFillCheckCircle, AiFillMinusCircle } from "react-icons/ai";

interface IProps {
  checklist: IChecklistWithResponses[];
}

export const ChecklistModalContent = ({ checklist }: IProps) => {
  return (
    <div className="flex flex-1 flex-col max-w-[700px]">
      {checklist?.map(({ is_done, label, id, required }) => {
        return (
          <div
            key={id}
            className={`shadow-lg border-slate-300 border flex flex-row flex-1 p-2 m-2 items-center rounded-lg relative ${
              is_done ? `bg-green-500/20` : `bg-red-500/20`
            }`}
          >
            {is_done ? (
              <div className="mr-3">
                <AiFillCheckCircle color="green" size={20} />
              </div>
            ) : (
              <div className="mr-3">
                <AiFillMinusCircle color="gray" size={20} />
              </div>
            )}
            <div>{label}</div>
            <div className="absolute top-[-12px] right-[-5px] text-red-500 text-2xl">
              {required ? "*" : ""}
            </div>
          </div>
        );
      })}
    </div>
  );
};
